import { Transition } from 'framer-motion';

export const defaultTransition: Transition = {
  duration: 0.2,
  ease: [0.32, 0.72, 0, 1],
};
